import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import * as orderActions from './../../../../../../../actions/orderAction';
import * as tourPropertyAction from './../../../../../../../actions/tourPropertyAction';
import RedeemTour from './RedeemTour';

const mapStateToProps = state => {
    return {
        redeemData: state.orderReducer.detail.redeemData,
        orderReducer: state.orderReducer,
        tourPropertyReducer: state.tourPropertyReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkRedeem: (data) => dispatch(orderActions.checkRedeemOrderItem(data)),
        redeemTour: (data, index, callBack) => dispatch(orderActions.redeemOrderItem(data, index, callBack)),
        setInfoRedeem: (redeemData) => dispatch(orderActions.setInfoRedeemItem(redeemData)),
        dataPropertyLoadAllAction: (filter) => dispatch(tourPropertyAction.dataPropertyLoadAllAction(filter)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RedeemTour));